import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';

import SidePanelRow from './SidePanelRow';
import row1 from './rowdata/row1.json';

const useStyles = makeStyles(theme => ({ 
    drawer: {
        flexShrink: 0,
    },
    topFiller: {        
        width: '35vw',
        height:'60px',
        marginBottom:'10px',
    },
}));

export default function SidePanel(props) {
    const classes = useStyles();
    const { open } = props;
    const { onClose, setMakeup } = props;    
    // Configuration for a fixed drawer
    const drawerFixedConfig = {
        variant:'permanent',
        anchor:'right',
        className: classes.drawer,
    }
    // Configuration for a hideable drawer
    const drawerHideConfig = {
        onClose: _ => onClose(),
        open: open,
        anchor:'right',
        className: classes.drawer,
    }

    const rowData = [row1];    

    return (     
        <div>
            <Hidden mdUp>
                <Drawer id='small-resolution-drawer' {...drawerHideConfig}>
                    <SidePanelContent classes={classes}
                        rowData={rowData}
                        setMakeup={setMakeup}
                    />
                </Drawer>
            </Hidden>                
            <Hidden smDown>
                <Drawer id='large-resolution-drawer' {...drawerFixedConfig}>
                    <SidePanelContent classes={classes}
                        rowData={rowData}
                        setMakeup={setMakeup}
                    />
                </Drawer>
            </Hidden>
        </div>   
    )
}

function SidePanelContent(props) {
    const { classes, rowData } = props;
    const { setMakeup } = props;    
    const rowStyle={
        maxWidth:'35vw',
        overflowX:'auto',
    }
    return (        
        <div>
            <div className={classes.topFiller}/>
            <Divider></Divider>
            <Typography variant='h4' style={{margin:'15px 40px'}}>Hair</Typography>
            <div id='hair-row' style={rowStyle}>
                <SidePanelRow
                    data={rowData[0]} 
                    onClick={value => setMakeup('hair', value)}
                />
            </div>
            
        </div>
        
    )
}